import React, { useEffect, useRef } from 'react';
import { ArrowLeft, ArrowRight, Stethoscope, FileText, Sparkles, Menu, Volume2, VolumeX, Inbox, Mic, Play } from 'lucide-react';


const logoUrl = '/logo.png';

const ArrowForwardIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7 1L13 7L7 13M13 7H1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const WhiteboardIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <rect x="1" y="1" width="12" height="9" rx="1" stroke="#666" strokeWidth="1.5"/>
    <path d="M4 13H10M7 10V13" stroke="#666" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4 5.5L6 7.5L10 4" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MicIconBlue = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 1C8.34 1 7 2.34 7 4V10C7 11.66 8.34 13 10 13C11.66 13 13 11.66 13 10V4C13 2.34 11.66 1 10 1Z" fill="#1132ee"/>
    <path d="M4 10C4 13.31 6.69 16 10 16C13.31 16 16 13.31 16 10" stroke="#1132ee" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 16V19" stroke="#1132ee" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const EarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 2C6.69 2 4 4.69 4 8C4 10.21 5.18 12.14 6.94 13.22C7.59 13.62 8 14.33 8 15.1V17C8 17.55 8.45 18 9 18H11C11.55 18 12 17.55 12 17V15.1C12 14.33 12.41 13.62 13.06 13.22C14.82 12.14 16 10.21 16 8C16 4.69 13.31 2 10 2Z" stroke="#1132ee" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 6C9.45 6 9 6.45 9 7V9C9 9.55 9.45 10 10 10C10.55 10 11 9.55 11 9V7C11 6.45 10.55 6 10 6Z" fill="#1132ee"/>
  </svg>
);

// RMS amplitude data extracted from demo_full.wav (300 buckets, normalized 0-1)
const WAV_RMS = [0.001,0.001,0.861,0.528,0.38,0.123,0.004,0.003,0.003,0.002,0.002,0.002,0.001,0.001,0.001,0.002,0.704,0.149,0.362,0.078,0.004,0.003,0.003,0.165,0.702,0.13,0.028,0.004,0.004,0.003,0.003,0.004,0.003,0.004,0.004,0.004,0.004,0.003,0.003,0,0.003,0.858,0.136,0.386,0.054,0.005,0.004,0.002,0.005,0.759,0.46,0.793,0.14,0.012,0.63,0.414,0.67,0.304,0.153,0.081,0.003,0.003,0.002,0.003,0.003,0.003,0.003,0.003,0.004,0.004,0.002,0.002,0.547,0.167,0.301,0.045,0.003,0.003,0.091,0.654,0.611,0.5,0.674,0.312,0.046,0.004,0.003,0.003,0.003,0.003,0.003,0.002,0.003,0.003,0.004,0.003,0.002,0,0.518,0.374,0.391,0.065,0.01,0.005,0.002,1,0.7,0.828,0.958,0.618,0.772,0.688,0.328,0.561,0.297,0.793,0.636,0.482,0.606,0.573,0.653,0.407,0.682,0.692,0.584,0.483,0.376,0.724,0.481,0.622,0.47,0.529,0.515,0.427,0.266,0.335,0.143,0.034,0.047,0.577,0.429,0.584,0.474,0.854,0.61,0.593,0.591,0.595,0.392,0.756,0.492,0.462,0.499,0.29,0.353,0.321,0.254,0.125,0.174,0.637,0.693,0.471,0.499,0.629,0.274,0.94,0.468,0.392,0.535,0.614,0.634,0.343,0.62,0.59,0.59,0.366,0.32,0.515,0.553,0.561,0.474,0.258,0.674,0.172,0.672,0.347,0.139,0.043,0.515,0.974,0.851,0.446,0.696,0.285,0.482,0.374,0.288,0.127,0.034,0.578,0.788,0.93,0.816,0.279,0.277,0.452,0.268,0.043,0.55,0.917,0.487,0.578,0.422,0.414,0.35,0.062,0.031,0.785,0.629,0.889,0.581,0.608,0.539,0.556,0.527,0.416,0.163,0.305,0.064,0.06,0.865,0.583,0.756,0.396,0.268,0.168,0.036,0.733,0.803,0.282,0.103,0.007,0.005,0.002,0.399,0.841,0.313,0.028,0.006,0.854,0.674,0.459,0.402,0.225,0.021,0.441,0.68,0.509,0.753,0.194,0.723,0.559,0.298,0.482,0.54,0.476,0.462,0.41,0.446,0.542,0.397,0.505,0.313,0.413,0.311,0.433,0.399,0.145,0.306,0.133,0.027,0.675,0.982,0.544,0.586,0.654,0.263,0.379,0.271,0.437,0.401,0.205,0.079,0.005,0.003,0.002,0.484,0.451,0.31,0.006];

const SoundWave = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  // Start offset negative so canvas begins empty and bars scroll in from right
  const offsetRef = useRef(-343);
  const rafRef = useRef<number>(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const W = canvas.width;
    const H = canvas.height;
    const barW = 3;
    const gap = 3;
    const step = barW + gap;
    const totalBars = Math.ceil(W / step) + 4;
    const centerY = H / 2;
    const maxBarH = H - 4;
    const minBarH = 2;
    // Speed: scroll through all 300 buckets over ~43s (audio duration)
    // Each bucket = 43131ms/300 = ~144ms of audio
    // At 60fps, 144ms = ~8.6 frames per bucket
    // step = 6px per bar, so speed = 6/8.6 ≈ 0.7px/frame
    const speed = 0.7;
    const seqLen = WAV_RMS.length;

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = 'white';

      for (let i = 0; i < totalBars; i++) {
        const x = i * step - (offsetRef.current % step);
        const rawIdx = Math.floor(offsetRef.current / step) + i;
        const seqIdx = rawIdx % seqLen;
        const rms = WAV_RMS[seqIdx];
        // Map rms (0-1) to bar height — silence stays very flat (minBarH), peaks fill height
        const barH = minBarH + rms * (maxBarH - minBarH);
        const radius = barW / 2;
        const y = centerY - barH / 2;

        ctx.beginPath();
        ctx.roundRect(x, y, barW, barH, radius);
        ctx.fill();
      }

      offsetRef.current += speed;
      rafRef.current = requestAnimationFrame(draw);
    };

    rafRef.current = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return (
    <div className="flex items-center justify-center w-full px-2" style={{ height: '56px' }}>
      <canvas
        ref={canvasRef}
        width={343}
        height={56}
        style={{ display: 'block', width: '100%', height: '56px' }}
      />
    </div>
  );
};

interface PhoneMockupProps {
  isDictating: boolean;
  onDictateStart: (e?: React.MouseEvent | React.TouchEvent) => void;
  onDictateEnd: () => void;
  onNextField: () => void;
  onPrevField: () => void;
  showOverlay?: boolean;
  onStartDemo?: () => void;
  onShowChooser?: () => void;
  onStartLive?: () => void;
  isMuted?: boolean;
  onToggleMute?: () => void;
  highlightDictation?: boolean;
  showDictationArrow?: boolean;
  showLiveTest?: boolean;
  showPostDemo?: boolean;
}

export const PhoneMockup: React.FC<PhoneMockupProps> = ({
  isDictating,
  onDictateStart,
  onDictateEnd,
  onNextField,
  onPrevField,
  showOverlay = false,
  onStartDemo,
  onShowChooser,
  onStartLive,
  isMuted = false,
  onToggleMute,
  highlightDictation = false,
  showDictationArrow = false,
  showLiveTest = false,
  showPostDemo = false,
}) => {
  const macros = [
    'Normal Physical Exam',
    'ROS Negative',
    'Diabetes Follow-Up',
    'URI/Common Cold',
    'HTN Follow-Up',
    'Well Child Visit',
    'Annual Physical Exam',
    'Medication Refill',
    'Blood Pressure Management Review',
    'Hypertension Monitoring Session',
  ];

  const navCommands = ['New line / Next line', 'New paragraph', 'Next field', 'Previous field', 'Next item / number'];
  const editCommands = ['Select', 'Deselect', 'Undo', 'Redo', 'Scratch that', 'Delete that', 'Create/start/insert numbered list', 'End list'];

  return (
    <div
      className="w-[375px] bg-[#f7f7f7] rounded-[54px] shadow-[0_30px_60px_rgba(0,0,0,0.15)] border-[10px] border-slate-200 overflow-hidden flex flex-col relative"
      style={{ fontFamily: 'Lato, sans-serif' }}
    >
      <style>{`@keyframes soundWave { 0%,100%{transform:scaleY(1);opacity:0.7} 50%{transform:scaleY(1.8);opacity:1} }`}</style>

      {/* Initial Overlay */}
      {showOverlay && !showPostDemo && (
        <div className="absolute inset-0 bg-white/95 backdrop-blur-sm z-50 flex flex-col items-center justify-center p-8">
          <img src={logoUrl} alt="Commure Logo" className="h-12 w-auto object-contain mb-6" />
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Commure Dictation</h2>
          <p className="text-slate-500 text-center mb-10 text-sm">Experience the future of clinical documentation.</p>
          <div className="w-full space-y-4">
            <button onClick={onShowChooser ?? onStartDemo} className="w-full bg-[#1132ee] text-white py-4 rounded-xl font-semibold text-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2">
              <Volume2 className="w-5 h-5" />
              <span>View Demo</span>
            </button>
            <p className="text-slate-400 text-xs text-center">Turn sound on to hear</p>
            <button onClick={onToggleMute} className={`w-full py-3 rounded-xl font-medium text-sm transition-colors flex items-center justify-center space-x-2 ${isMuted ? 'bg-slate-100 text-slate-500' : 'bg-green-50 text-green-700 border border-green-200'}`}>
              {isMuted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
              <span>{isMuted ? 'Sound Off' : 'Sound On'}</span>
            </button>
            {showLiveTest && (
              <button onClick={onStartLive} className="w-full bg-white text-[#1132ee] border-2 border-[#1132ee] py-3 rounded-xl hover:bg-blue-50 transition-colors flex flex-col items-center justify-center">
                <div className="flex items-center space-x-2">
                  <Mic className="w-5 h-5" />
                  <span className="font-semibold text-lg">Test Live</span>
                </div>
                <span className="text-slate-400 text-[10px] mt-0.5">(Work in Progress - Not Fully Configured)</span>
              </button>
            )}
          </div>
        </div>
      )}

      {/* Post-Demo Overlay */}
      {showPostDemo && (
        <div className="absolute inset-0 bg-white/95 backdrop-blur-sm z-50 flex flex-col items-center justify-center p-8">
          <img src={logoUrl} alt="Commure Logo" className="h-12 w-auto object-contain mb-4" />
          <h2 className="text-xl font-bold text-slate-900 mb-1">Thanks for watching!</h2>
          <p className="text-slate-500 text-center mb-8 text-sm">Ready to get started with Commure Dictation?</p>
          <div className="w-full space-y-3">
            <button
              className="w-full bg-[#1132ee] text-white py-4 rounded-xl font-semibold text-base hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88" className="w-5 h-5 fill-current">
                <path d="M0 12.402l35.687-4.86.016 34.423-35.703.206zm35.67 33.529l.016 34.453L0 76.03V46.135zM40.336 6.36L87.868 0v41.207l-47.532.328zM87.868 46.24V88L40.336 81.33v-35.3z" />
              </svg>
              <span>Download for Windows</span>
            </button>
            <button
              onClick={onShowChooser ?? onStartDemo}
              className="w-full bg-white text-[#1132ee] border-2 border-[#1132ee] py-3 rounded-xl font-semibold text-base hover:bg-blue-50 transition-colors flex items-center justify-center space-x-2"
            >
              <Play className="w-4 h-4" />
              <span>Watch Another Demo</span>
            </button>
          </div>
        </div>
      )}

      {/* Status Bar */}
      <div className="h-[38px] flex items-center justify-between px-6 shrink-0 bg-[#f7f7f7]">
        <span className="text-[15px] font-bold text-black">9:41</span>
        <div className="flex items-center space-x-1.5">
          <svg width="17" height="11" viewBox="0 0 17 11" fill="none">
            <rect x="0" y="3" width="3" height="8" rx="0.5" fill="black"/>
            <rect x="4.5" y="2" width="3" height="9" rx="0.5" fill="black"/>
            <rect x="9" y="1" width="3" height="10" rx="0.5" fill="black"/>
            <rect x="13.5" y="0" width="3" height="11" rx="0.5" fill="black"/>
          </svg>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
            <path d="M8 2.5C10.2 2.5 12.2 3.4 13.6 4.9L15 3.5C13.2 1.6 10.7 0.5 8 0.5C5.3 0.5 2.8 1.6 1 3.5L2.4 4.9C3.8 3.4 5.8 2.5 8 2.5Z" fill="black"/>
            <path d="M8 5.5C9.4 5.5 10.7 6.1 11.6 7L13 5.6C11.7 4.3 9.9 3.5 8 3.5C6.1 3.5 4.3 4.3 3 5.6L4.4 7C5.3 6.1 6.6 5.5 8 5.5Z" fill="black"/>
            <circle cx="8" cy="10" r="1.5" fill="black"/>
          </svg>
          <svg width="25" height="12" viewBox="0 0 25 12" fill="none">
            <rect x="0.5" y="0.5" width="21" height="11" rx="3.5" stroke="black" strokeOpacity="0.35"/>
            <rect x="2" y="2" width="18" height="8" rx="2" fill="black"/>
            <path d="M23 4V8C23.8 7.5 24.5 6.8 24.5 6C24.5 5.2 23.8 4.5 23 4Z" fill="black" fillOpacity="0.4"/>
          </svg>
        </div>
      </div>

      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 shrink-0 bg-[#f7f7f7]">
        <div className="w-9 h-9" />
        {isDictating ? (
          <div className="flex items-center gap-1 bg-[#f1f3fe] px-3 h-9 rounded-lg">
            <div className="w-4 h-4 flex items-center justify-center"><EarIcon /></div>
            <span className="text-[15px] font-bold text-[#1132ee] tracking-[0.15px]" style={{ fontFamily: 'Lato, sans-serif', fontFeatureSettings: "'ss07'" }}>Listening...</span>
          </div>
        ) : (
          <div className="flex items-center gap-1 bg-[#edf7ee] px-3 h-9 rounded-lg">
            <svg className="w-4 h-4" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" fill="#2f6a32"/><path d="M6 10L9 13L14 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            <span className="text-[15px] font-bold text-[#2f6a32] tracking-[0.15px]" style={{ fontFamily: 'Lato, sans-serif', fontFeatureSettings: "'ss07'" }}>Connected to Computer</span>
          </div>
        )}
        <button className="w-9 h-9 flex items-center justify-center rounded-lg">
          <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none"><circle cx="4" cy="10" r="1.5" fill="#666"/><circle cx="10" cy="10" r="1.5" fill="#666"/><circle cx="16" cy="10" r="1.5" fill="#666"/></svg>
        </button>
      </div>

      {/* Card Area */}
      <div className="flex-1 px-4 py-3 flex flex-col min-h-0 bg-[#f7f7f7]">
        <div className="flex-1 bg-white rounded-[12px] shadow-[0px_4px_16px_2px_rgba(0,0,0,0.07)] flex flex-col overflow-hidden min-h-0">
          <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
            <div className="px-4 py-3 shrink-0">
              <span className="text-[13px] font-bold text-[#666]">Voice Commands</span>
            </div>
            <div className="h-px bg-black/10 mx-4 shrink-0" />
            <div className="flex-1 overflow-auto py-4">
              <div className="px-4 py-3 flex flex-col gap-3">
                <div className="flex items-center gap-1.5">
                  <ArrowForwardIcon />
                  <span className="text-[12px] text-[#666]">Navigation</span>
                </div>
                <div className="flex flex-wrap gap-1">
                  {navCommands.map((cmd) => (
                    <span key={cmd} className="bg-[#f2f2f2] text-[#666] text-[12px] px-2 h-7 flex items-center rounded-lg">{cmd}</span>
                  ))}
                </div>
              </div>
              <div className="h-px bg-black/10 mx-4" />
              <div className="px-4 py-3 flex flex-col gap-3">
                <div className="flex items-center gap-1.5">
                  <WhiteboardIcon />
                  <span className="text-[12px] text-[#666]">Editing</span>
                </div>
                <div className="flex flex-wrap gap-1">
                  {editCommands.map((cmd) => (
                    <span key={cmd} className="bg-[#f2f2f2] text-[#666] text-[12px] px-2 h-7 flex items-center rounded-lg">{cmd}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center gap-1 mt-3 mb-1 shrink-0">
          <div className="rounded-full w-1.5 h-1.5 bg-[#e6e6e6]" />
          <div className="rounded-full w-1.5 h-1.5 bg-[#666]" />
          <div className="rounded-full w-1.5 h-1.5 bg-[#e6e6e6]" />
        </div>
      </div>

      {/* Bottom Controls */}
      {isDictating ? (
        <div className="shrink-0" style={{ background: 'linear-gradient(to bottom, #405bf2, #1132ee)' }}>
          <div className="flex flex-col gap-4 items-center px-4 pt-4 pb-5">
            <button
              onMouseDown={onDictateEnd}
              onTouchEnd={onDictateEnd}
              className="w-full h-24 rounded-[49px] border-2 border-white flex items-center justify-center gap-3 active:opacity-80 hover:bg-white/10 transition-all"
            >
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect x="8" y="8" width="16" height="16" rx="2" fill="white"/>
              </svg>
              <span className="text-[17px] font-bold text-white tracking-[0.34px]">Stop Dictation</span>
            </button>
            <div className="flex items-center justify-between w-full py-1">
              <button onClick={showLiveTest ? onPrevField : undefined} className="flex items-center gap-2 text-white font-bold flex-1 justify-center">
                <ArrowLeft className="w-5 h-5 stroke-[2.5]" />
                <span className="text-[17px]">Prev Field</span>
              </button>
              <div className="w-px self-stretch bg-[#cfd6fc]" />
              <button onClick={showLiveTest ? onNextField : undefined} className="flex items-center gap-2 text-white font-bold flex-1 justify-center">
                <span className="text-[17px]">Next Field</span>
                <ArrowRight className="w-5 h-5 stroke-[2.5]" />
              </button>
            </div>
          </div>
          <div className="flex items-center justify-center px-4 h-[62px]">
            <SoundWave />
          </div>
          <div className="h-6 bg-[#1132ee] flex items-end justify-center pb-2">
            <div className="w-[134px] h-[5px] bg-white rounded-full" />
          </div>
        </div>
      ) : (
        <div className="shrink-0 bg-white border-t-2 border-[#1132ee]">
          <div className="flex flex-col gap-4 items-center px-4 pt-4 pb-5">

            <button
              onMouseDown={showLiveTest ? onDictateStart : undefined}
              onMouseUp={showLiveTest ? onDictateEnd : undefined}
              onMouseLeave={showLiveTest ? onDictateEnd : undefined}
              onTouchStart={showLiveTest ? onDictateStart : undefined}
              onTouchEnd={showLiveTest ? onDictateEnd : undefined}
              className={`w-full h-24 rounded-[65px] bg-[#1132ee] flex items-center justify-center gap-3 transition-all duration-200 ${showLiveTest ? 'active:scale-[0.98]' : 'cursor-default'}`}
            >
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M11 8L24 16L11 24V8Z" fill="white"/>
              </svg>
              <span className="text-[17px] font-bold text-white tracking-[0.34px]">Press / Hold to Dictate</span>
            </button>
            <div className="flex items-center justify-between w-full py-1">
              <button onClick={showLiveTest ? onPrevField : undefined} className="flex items-center gap-2 text-[#1132ee] font-bold flex-1 justify-center">
                <ArrowLeft className="w-5 h-5 stroke-[2.5]" />
                <span className="text-[17px]">Prev Field</span>
              </button>
              <div className="w-px self-stretch bg-black/10" />
              <button onClick={showLiveTest ? onNextField : undefined} className="flex items-center gap-2 text-[#1132ee] font-bold flex-1 justify-center">
                <span className="text-[17px]">Next Field</span>
                <ArrowRight className="w-5 h-5 stroke-[2.5]" />
              </button>
            </div>
          </div>

          {/* Bottom Nav */}
          <div className="flex items-start justify-around px-2 pt-1 pb-2 border-t border-black/10">
            <button className="flex flex-col items-center gap-1 pt-1 pb-2 flex-1">
              <div className="p-1"><Stethoscope className="w-5 h-5 text-[#808080]" /></div>
              <span className="text-[10px] font-bold text-[#808080] tracking-[-0.36px]">Visits</span>
            </button>
            <button className="flex flex-col items-center gap-1 pt-1 pb-2 flex-1">
              <div className="p-1"><FileText className="w-5 h-5 text-[#808080]" /></div>
              <span className="text-[10px] font-bold text-[#808080] tracking-[-0.36px]">My Scribes</span>
            </button>
            <button className="flex flex-col items-center gap-1 pt-1 pb-2 flex-1">
              <div className="p-1"><Sparkles className="w-5 h-5 text-[#808080]" /></div>
              <span className="text-[10px] font-bold text-[#808080] tracking-[-0.36px]">Assistant</span>
            </button>
            <button className={`flex flex-col items-center gap-1 pt-0 pb-2 flex-1 border-t-2 border-[#1132ee] relative ${highlightDictation ? 'outline outline-2 outline-[#1132ee] outline-offset-[-2px] rounded-lg' : ''}`}>
              {highlightDictation && (
                <span className="absolute inset-0 rounded-lg animate-ping bg-[#1132ee]/20 pointer-events-none" />
              )}
              <div className="p-1 relative z-10"><MicIconBlue /></div>
              <span className="text-[10px] font-bold text-[#1132ee] tracking-[-0.36px] relative z-10">Dictation</span>
            </button>
            <button className="flex flex-col items-center gap-1 pt-1 pb-2 flex-1">
              <div className="p-1"><Inbox className="w-5 h-5 text-[#808080]" /></div>
              <span className="text-[10px] font-bold text-[#808080] tracking-[-0.36px]">Inbox</span>
            </button>
            <button className="flex flex-col items-center gap-1 pt-1 pb-2 flex-1">
              <div className="p-1"><Menu className="w-5 h-5 text-[#808080]" /></div>
              <span className="text-[10px] font-bold text-[#808080] tracking-[-0.36px]">More</span>
            </button>
          </div>

          {/* Home Indicator */}
          <div className="h-6 bg-white flex items-end justify-center pb-2">
            <div className="w-[134px] h-[5px] bg-black rounded-full" />
          </div>
        </div>
      )}
    </div>
  );
};
